export default __webpack_public_path__ + "static/rule-7-8f03dccaec0524460bfdcb20fa2f9b4f.svg";